import * as Y from "yjs";

/*
  Kommentare an einer Textstelle festmachen, die Änderungen übersteht.

  ---------------------------------------------------------------
  Warum hier nicht mehr steht
  ---------------------------------------------------------------

  Diese Datei beschrieb einmal ein eigenes Dokumentmodell: eine Liste von
  Absätzen mit Kennungen, wie es die Vorlagen der Verwaltung haben. Das war
  der erste Editor. Seit Quill ist ein Dokument ein einziger Text mit
  Auszeichnungen — die Absatzverwaltung übernimmt Quill.

  Übrig bleibt das, was Quill NICHT mitbringt: die Verankerung von
  Kommentaren.

  ---------------------------------------------------------------
  Und warum es die braucht
  ---------------------------------------------------------------

  An einer Vorlage der Verwaltung genügen Start und Ende als Zahlen — der
  Text ändert sich nicht. In einem Dokument, in das gerade jemand schreibt,
  wandert jede Zahl bei jedem eingefügten Zeichen: Schreibt Christian einen
  Satz davor, säße der Kommentar plötzlich mitten im Wort.

  Yjs kennt dafür „relative Positionen". Sie zeigen nicht auf eine Zahl,
  sondern auf eine Stelle im Text, und bleiben dort. Gespeichert wird das
  Paar aus Anfang und Ende als Zeichenkette im Feld `verankerung`.
*/

export function verankere(text, start, ende) {
  const von = Y.createRelativePositionFromTypeIndex(text, start);
  const bis = Y.createRelativePositionFromTypeIndex(text, ende);
  return JSON.stringify({
    von: Array.from(Y.encodeRelativePosition(von)),
    bis: Array.from(Y.encodeRelativePosition(bis)),
  });
}

/*
  Zurück zu Zahlen — für das Hervorheben im Text.

  Gibt `null` zurück, wenn die Stelle nicht mehr existiert: Wer den Text
  löscht, an dem ein Kommentar hing, löscht damit seinen Anker. Der
  Kommentar bleibt am Rand stehen, er zeigt nur nirgendwo mehr hin — das ist
  ehrlicher, als ihn an eine geratene Stelle zu setzen.
*/
export function loeseVerankerung(doc, verankerung) {
  if (!verankerung) return null;
  try {
    const roh = JSON.parse(verankerung);
    const von = Y.createAbsolutePositionFromRelativePosition(
      Y.decodeRelativePosition(Uint8Array.from(roh.von)),
      doc
    );
    const bis = Y.createAbsolutePositionFromRelativePosition(
      Y.decodeRelativePosition(Uint8Array.from(roh.bis)),
      doc
    );
    if (!von || !bis) return null;
    return { start: von.index, ende: bis.index };
  } catch {
    return null;
  }
}
